module.exports = __webpack_public_path__ + "img/iot-scene-warehouse.b892b398.png";